"use client";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import "../App.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.message.trim()) {
      alert("Please fill in your name and message.");
      return;
    }

    const whatsappMessage = `*New Contact Form Submission*

*Name:* ${formData.name}
*Email:* ${formData.email || "Not provided"}

*Message:*
${formData.message}`;

    const phoneNumber = "919924382499";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, "_blank");

    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="page-wrapper light-section min-vh-100">
      {/* Hero Banner Section */}
      <div className="page-banner position-relative">
        <div className="glowing-orb primary top-50 start-50 translate-middle" style={{ width: '400px', height: '400px', opacity: 0.5 }}></div>
        <div className="container position-relative z-1">
          <h1 className="page-banner-title text-white">Contact Us</h1>
          <div className="page-banner-breadcrumb text-light opacity-75">
            <Link to="/" className="text-light">Home</Link> <span>/</span> Contact Us
          </div>
        </div>
      </div>

      <div className="container section-padding position-relative">
        <div className="glowing-orb accent bottom-0 end-0" style={{ width: '300px', height: '300px' }}></div>

        {/* Equal Height Row */}
        <div className="row g-4 align-items-stretch position-relative z-1">
          {/* Contact Info Card */}
          <div className="col-lg-5 col-12">
            <div className="white-card p-4 p-md-5 rounded-4 shadow-sm border h-100 d-flex flex-column justify-content-between">
              <div>
                <span className="section-pill mb-3 align-self-start">Get in Touch</span>
                <h3 className="section-heading text-dark mb-3">Contact <span className="text-primary fst-italic">Details</span></h3>
                <p className="text-muted-dark mb-4">
                  Have questions about our collection or need assistance? Reach out to us. We are here to help you build your dream space.
                </p>

                {/* Contact Items */}
                <div className="d-flex flex-column gap-3 mb-4">
                  {/* Address */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '42px', height: '42px', fontSize: '1.1rem' }}>
                      <FaMapMarkerAlt />
                    </div>
                    <div>
                      <h6 className="fw-bold text-dark mb-1" style={{ fontSize: '0.95rem' }}>Address</h6>
                      <p className="text-muted-dark small mb-0" style={{ lineHeight: '1.5' }}>
                        <a href="https://share.google/wGLZ3vJLBz6zjMhCd" target="_blank" rel="noopener noreferrer" className="text-muted-dark text-decoration-none">
                          Block No.221, New Ring Road,<br />
                          Saniya Kosmada Chokdi, Kosmada - 395006.
                        </a>
                      </p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '42px', height: '42px', fontSize: '1.1rem' }}>
                      <FaPhoneAlt />
                    </div>
                    <div>
                      <h6 className="fw-bold text-dark mb-1" style={{ fontSize: '0.95rem' }}>Phone</h6>
                      <p className="text-muted-dark small mb-0" style={{ lineHeight: '1.6' }}>
                        <a href="tel:+917202057575" className="text-muted-dark text-decoration-none">+91 72020 57575</a> (Customer Care)<br />
                        <a href="tel:+919624882499" className="text-muted-dark text-decoration-none">+91 96248 82499</a> (Vikram Sakariya)<br />
                        <a href="tel:+919924382499" className="text-muted-dark text-decoration-none">+91 99243 82499</a> (Rakshit Sakariya)
                      </p>
                    </div>
                  </div>

                  {/* WhatsApp */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '42px', height: '42px', fontSize: '1.2rem' }}>
                      <FaWhatsapp />
                    </div>
                    <div>
                      <h6 className="fw-bold text-dark mb-1" style={{ fontSize: '0.95rem' }}>WhatsApp Inquiry</h6>
                      <p className="text-muted-dark small mb-0" style={{ lineHeight: '1.5' }}>
                        <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="text-dark text-decoration-none fw-bold">+91 99243 82499</a> (Rakshit Sakariya)<br />
                        <a href="https://chat.whatsapp.com/CciDF9dx73pD3eyBUtrWnV" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none fw-semibold">Join WhatsApp Community &rarr;</a>
                      </p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '42px', height: '42px', fontSize: '1.1rem' }}>
                      <FaEnvelope />
                    </div>
                    <div>
                      <h6 className="fw-bold text-dark mb-1" style={{ fontSize: '0.95rem' }}>Email</h6>
                      <p className="text-muted-dark small mb-0">
                        <a href="mailto:kamdhenusteelindustries99@gmail.com" className="text-muted-dark text-decoration-none">kamdhenusteelindustries99@gmail.com</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Social Media Footer Section */}
              <div className="pt-3 border-top">
                <h6 className="font-serif fw-bold text-dark mb-3" style={{ fontSize: '1.05rem' }}>
                  Follow Us On <span className="text-primary fst-italic">Social Media</span>
                </h6>
                <div className="d-flex align-items-center gap-3">
                  <a
                    href="https://www.facebook.com/kamdhenu.steelindustries.2025"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="theme-social-btn facebook"
                    title="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                  <a
                    href="https://www.instagram.com/kamdhenusteelindustries1995/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="theme-social-btn instagram"
                    title="Instagram"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://www.youtube.com/@KAMDHENUSTEELINDUSTRIES"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="theme-social-btn youtube"
                    title="YouTube"
                  >
                    <FaYoutube />
                  </a>
                  <a
                    href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="theme-social-btn whatsapp"
                    title="WhatsApp"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Card */}
          <div className="col-lg-7 col-12">
            <div className="white-card p-4 p-md-5 rounded-4 shadow-sm border h-100 d-flex flex-column justify-content-between">
              <div>
                <h3 className="section-heading text-dark mb-3">Send us a <span className="text-primary fst-italic">Message</span></h3>
                <p className="text-muted-dark mb-4 small">
                  Fill out the form below to send an instant inquiry to our team via WhatsApp.
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label text-dark small fw-bold">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control form-control-lg bg-light text-dark border"
                      placeholder="Enter your name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label text-dark small fw-bold">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control form-control-lg bg-light text-dark border"
                      placeholder="Enter your email address"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label text-dark small fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control form-control-lg bg-light text-dark border"
                      rows="4"
                      placeholder="Write your furniture inquiry or requirements here..."
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary contact-submit-btn w-100 rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 hover-lift shadow-sm">
                    <FaWhatsapp size={20} className="flex-shrink-0" /> <span>Send via WhatsApp</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-4 position-relative z-1">
          <div className="shadow-sm white-card p-2 p-md-3 rounded-4 border">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.7869905879325!2d72.91657370516022!3d21.200619166117022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04fe1ebd2c169%3A0x36c917ead0a54ece!2sKamdhenu%20Steel%20Industries!5e0!3m2!1sen!2sin!4v1788588430646!5m2!1sen!2sin"
              width="100%"
              height="380"
              className="contact-map-iframe"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Shree Kamdhenu Furniture Location Map"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
